export enum Queries {
  ComponentStatusList = 'ComponentStatusList',
  QueueStatusList = 'QueueStatusList',
}
